import { BhImageType } from 'models/BhImageType';
import { MediaSize } from 'models/ListViewProduct';
import { useSelector } from 'react-redux';
import { postNotifyMeRequest } from 'services/ApiVoyadoService';
import { selectSiteUrl, selectCdnUrl } from 'store/appShell/selector';
import { imageUrl } from 'utils/cdn';
import { mediaSize } from 'views/ProductPage/productMedia/themes/BGH/bigProductMedia';
import {
  getProductId,
  getVariantId,
  getPrice,
  getProductUrl,
  getProductImage,
  getProductShortDescription,
  getProductDescription
} from 'views/ProductPage/selector';
import * as rules from 'components/Input/validation';
import { withCurrentPage } from 'utils';

type isValidProps = {
  email: string;
  phone: string;
  setErrorEmail: (error?: string) => void;
  setErrorPhone: (error?: string) => void;
};

export const isValid = ({ email, phone, setErrorEmail, setErrorPhone }: isValidProps) => {
  let isValid = true;
  const emailError = rules.email(email);
  const phoneError = rules.phone(phone);
  if (emailError) {
    setErrorEmail(emailError);
    isValid = false;
  }
  if (phoneError) {
    setErrorPhone(phoneError);
    isValid = false;
  }
  return isValid;
};

type sendRequestProps = {
  email: string;
  phone: string;
  productName: string;
};

const MAX_LENGTH = 200;
const truncateDescription = (description?: string, shortDescription?: string): string => {
  const combinedStr = shortDescription + '<br>' + description;

  let truncatedStr = combinedStr.substring(0, MAX_LENGTH);

  const lastBrIndex = truncatedStr.lastIndexOf('<br>');

  if (lastBrIndex !== -1) {
    truncatedStr = truncatedStr.substring(0, lastBrIndex);
  } else {
    const lastPeriodIndex = truncatedStr.lastIndexOf('.');

    if (lastPeriodIndex !== -1) {
      truncatedStr = truncatedStr.substring(0, lastPeriodIndex + 1);
    }
  }

  return truncatedStr.trim().replace(/(<br>\s*)+$/, '');
};

export const useSendRequest = ({ email, phone, productName }: sendRequestProps) => {
  const productId = useSelector(withCurrentPage(getProductId));
  const variantId = useSelector(withCurrentPage(getVariantId));
  const price = useSelector(withCurrentPage(getPrice)).presentationPrice;
  const productUrl = useSelector(withCurrentPage(getProductUrl));
  const productImg = useSelector(withCurrentPage(getProductImage));
  const shortDescription = useSelector(withCurrentPage(getProductShortDescription)).content;

  const description = useSelector(getProductDescription)?.content;

  const siteUrl = useSelector(selectSiteUrl);
  const productUrlWithSite = siteUrl + productUrl;
  const cdnUrl = useSelector(selectCdnUrl);
  const mediaDimensions = mediaSize(MediaSize.Medium);
  const imageURl = imageUrl({
    cdnUrl,
    id: productImg?.id ?? '',
    name: productImg?.name ?? '',
    type: productImg?.type ?? BhImageType.Product,
    height: mediaDimensions.height,
    width: mediaDimensions.width
  });
  const parsUrl = new URL(siteUrl);
  const siteProtocol = parsUrl.protocol;

  const imageUrlWithProtocol = siteProtocol + imageURl;

  const skuString = variantId ? variantId : productId;

  const truncatedStr = truncateDescription(description, shortDescription);

  const sendRequest = () => {
    return postNotifyMeRequest({
      sku: skuString,
      price,
      phone,
      email,
      productName,
      productUrl: productUrlWithSite,
      productImg: imageUrlWithProtocol,
      productDescription: truncatedStr
    });
  };

  return sendRequest;
};
